import { render, staticRenderFns } from "./PreLayout.vue?vue&type=template&id=6bc54dcc&scoped=true&"
import script from "./PreLayout.vue?vue&type=script&lang=js&"
export * from "./PreLayout.vue?vue&type=script&lang=js&"
import style0 from "./PreLayout.vue?vue&type=style&index=0&id=6bc54dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc54dcc",
  null
  
)

export default component.exports